const genericColors = {
  inherit: 'inherit',
  current: 'currentColor',
  transparent: 'transparent',
};

export const dwColors = {
  black: '#000000',
  white: '#ffffff',
  'red-50': '#FFF8F6',
  'red-100': '#FFEDEA',
  'red-200': '#FFDAD4',
  'red-300': '#FFC3BB',
  'red-400': '#FF6565',
  'red-500': '#FF141F',
  'red-600': '#C70E18',
  'red-700': '#B90A18',
  'red-800': '#9A0714',
  'red-900': '#7B0911',
  'red-950': '#650810',
  'contrast-black-salmon': '#1E1E1E',
  'salmon-50': '#FDEDEF',
  'salmon-100': '#FAD3D5',
  'salmon-200': '#E7A4A1',
  'salmon-300': '#DB837D',
  'salmon-400': '#E46B5D',
  'salmon-500': '#EA5F44',
  'salmon-600': '#DC5743',
  'salmon-700': '#CA4E3C',
  'salmon-800': '#BE4736',
  'salmon-900': '#AF3E2A',
  'salmon-darker': '#BA615D',
  'cream-50': '#F4EEE8',
  'cream-100': '#E0D4CB',
  'cream-200': '#C9B7AB',
  'cream-300': '#B19A89',
  'cream-400': '#9E836D',
  'cream-500': '#8C6C53',
  'cream-600': '#7F624C',
  'cream-700': '#6F5541',
  'cream-800': '#614838',
  'cream-900': '#513A2D',
  'navy-50': '#DCF1FF',
  'navy-100': '#BADCF3',
  'navy-200': '#9DC1DD',
  'navy-300': '#7EA7C7',
  'navy-400': '#6593B5',
  'navy-500': '#4B80A4',
  'navy-600': '#3D7192',
  'navy-700': '#2E5D7B',
  'navy-800': '#204A64',
  'navy-900': '#0A354C',
  'gray-50': '#F9F9FA',
  'gray-100': '#EFF1F3',
  'gray-200': '#DFE3E7',
  'gray-300': '#CCD2D9',
  'gray-400': '#A1ACBA',
  'gray-500': '#758599',
  'gray-600': '#556577',
  'gray-700': '#4F5D6E',
  'gray-800': '#414C5A',
  'gray-900': '#333C47',
  'gray-950': '#2A313A',
  'yellow-50': '#FFF9E6',
  'yellow-100': '#FFEEBE',
  'yellow-200': '#FFDA7A',
  'yellow-300': '#FFBC31',
  'yellow-400': '#F69328',
  'yellow-500': '#C36E22',
  'yellow-600': '#97501B',
  'yellow-700': '#90481D',
  'yellow-800': '#793919',
  'yellow-900': '#602D13',
  'yellow-950': '#502412',
  'green-50': '#F3FCF3',
  'green-100': '#E0F7E1',
  'green-200': '#C0EEC2',
  'green-300': '#97E39A',
  'green-400': '#4FC254',
  'green-500': '#3D9541',
  'green-600': '#2E7031',
  'green-700': '#2B682D',
  'green-800': '#235625',
  'green-900': '#1C441D',
  'green-950': '#173718',
  'teal-50': '#f0fdfa',
  'teal-100': '#ccfbf1',
  'teal-200': '#99f6e4',
  'teal-300': '#5eead4',
  'teal-400': '#2dd4bf',
  'teal-500': '#14b8a6',
  'teal-600': '#0d9488',
  'teal-700': '#0f766e',
  'teal-800': '#115e59',
  'teal-900': '#134e4a',
  'teal-950': '#042f2e',
  'blue-focus': '#3776E2',
  'blue-focus-dark': '#0443AF',
  'blue-50': '#F5FAFF',
  'blue-100': '#E6F2FF',
  'blue-200': '#CDE5FE',
  'blue-300': '#ACD6FD',
  'blue-400': '#3FB4FA',
  'blue-500': '#158CC6',
  'blue-600': '#1D6993',
  'blue-700': '#1D6188',
  'blue-800': '#1D506E',
  'blue-900': '#1B3F55',
  'blue-950': '#0A354C',
  'pink-50': '#fdf2f8',
  'pink-100': '#fce7f3',
  'pink-200': '#fbcfe8',
  'pink-300': '#f9a8d4',
  'pink-400': '#f472b6',
  'pink-500': '#ec4899',
  'pink-600': '#db2777',
  'pink-700': '#be185d',
  'pink-800': '#9d174d',
  'pink-900': '#831843',
  'pink-950': '#500724',
  'rose-50': '#fff1f2',
  'rose-100': '#ffe4e6',
  'rose-200': '#fecdd3',
  'rose-300': '#fda4af',
  'rose-400': '#fb7185',
  'rose-500': '#f43f5e',
  'rose-600': '#e11d48',
  'rose-700': '#be123c',
  'rose-800': '#9f1239',
  'rose-900': '#881337',
  'rose-950': '#4c0519',
  'error-50': '#F1D6D5',
  'error-100': '#FFEDEA',
  'error-200': '#D99A98',
  'error-300': '#D57A7C',
  'error-400': '#DE5F5E',
  'error-500': '#E25349',
  'error-600': '#C70E18',
  'error-700': '#C14240',
  'error-800': '#8F272A',
  'error-900': '#7E2222',
  'success-100': '#7CA097',
  'surface-50': '#FAFBFB',
  'surface-100': '#F3F5F6',
  'surface-200': '#ECEFF1',
  'surface-250': '#DFE3E8',
  'surface-300': '#CCD2D9',
  'surface-400': '#A9B5C3',
  'surface-500': '#758599',
  'surface-600': '#4F5668',
  'surface-700': '#2B3149',
  'surface-800': '#1F253B',
  'surface-900': '#12172B',
  'surface-950': '#08090D',
  'neutral-50': '#F9F9FA',
  'neutral-100': '#F4EEE8',
  'ande-white': '#ffffff',
  'ande-white-transparent': '#FFFFFF00',
  'ande-white-45': '#FFFFFF73',
  'ande-white-50': '#FFFFFF80',
  'ande-white-78': '#FFFFFFC7',
  'ande-mint-dark': '#60E17B',
  'neutral-200': '#E7E2D9',
  'neutral-300': '#D6D1C9',
  'neutral-400': '#A19D97',
  'neutral-600': '#65635F',
  'ande-black': '#262626',
  'ande-black-transparent': '#26262600',
  'ande-black-8': '#26262614',
  'ande-black-16': '#26262629',
  'ande-black-25': '#26262640',
  'ande-black-46': '#26262675',
  'ande-gray': '#42484D',
  'ande-mint': '#85FE9D',
  'ande-olive-50': '#F3FAF0',
  'ande-olive-100': '#E3F3DD',
  'ande-olive-200': '#BFE0B1',
  'ande-olive-300': '#A5D392',
  'ande-olive-400': '#799A6B',
  'ande-olive-500': '#607B54',
  'ande-error': '#FF4949',
  'ande-error-light': '#FF9999',
  'ande-error-lighter': '#FFE5E5',
  'ande-error-dark': '#C70E18',
  'ande-system-error-200': '#E00000',
  'ande-success': '#3CA059',
  'ande-success-light': '#6BC786',
  'ande-success-dark': '#2E7A44',
  'ande-warning': '#FFE139',
  'ande-warning-light': '#FFEB7A',
  'ande-warning-dark': '#C68025',
  'ande-caution': '#C07B22',
  'ande-availability-positive': '#3A7B22',
  'ande-availability-negative': '#C92A2A',
  'ande-availability-muted': '#6B6B6B',
  'ande-orange-50': '#F7E6DC',
  'ande-orange-100': '#F9CDBB',
  'ande-orange-200': '#FBB59A',
  'ande-orange-300': '#FD9C78',
  'ande-orange-400': '#FF8357',
  'ande-blue-50': '#DBF4F1',
  'ande-blue-100': '#BCDFE1',
  'ande-blue-200': '#9DCAD1',
  'ande-blue-300': '#7EB4C1',
  'ande-blue-400': '#5F9FB1',
  'ande-gray-50': '#FAFAFA',
  'ande-gray-75': '#F0EEEA',
  'ande-gray-100': '#EBEBEA',
  'ande-gray-200': '#CAC9C9',
  'ande-gray-300': '#959493',
  'ande-gray-400': '#777675',
  'ande-gray-500': '#484747',
  'ande-gray-600': '#343739',
  'ande-surface-50': '#FBFAF9',
  'ande-surface-100': '#F9F5EF',
  'ande-surface-150': '#F8F1E8',
  'ande-surface-200': '#F4EFDF',
  'ande-surface-300': '#ECE5CF',
  'ande-surface-400': '#928A84',
  'ande-surface-500': '#504C49',
};

export const colors = {
  ...genericColors,
  ...dwColors,
} as const;
